const useLogics = () => {
  const columns = [
    {
      title: "Tarih",
      key: "tarih",
      dataIndex: "tarih",
      width: 250,
      fixed: true,
    },
    {
      title: "Müşteri",
      key: "customer_name",
      dataIndex: "customer_name",
      width: 200,
    },
    {
      title: "Toplam",
      key: "daily_amount",
      dataIndex: "daily_amount",
      width: 200,
    },
    {
      title: "Gönderi Tipi",
      key: "par_delivery_type",
      dataIndex: "par_delivery_type",
      width: 200,
    },
    {
      title: "Standart Teslimat",
      key: "daily_std",
      dataIndex: "daily_std",
      width: 200,
    },
    {
      title: "Aynı Gün Teslimat",
      key: "daily_sd",
      dataIndex: "daily_sd",
      width: 200,
    },
    {
      title: "Ertesi Gün Teslimat",
      key: "daily_nd",
      dataIndex: "daily_nd",
      width: 200,
    },
  ];

  const excelColumns = [
    {
      title: "Tarih",
      key: "tarih",
    },
    {
      title: "Müşteri",
      key: "customer_name",
    },
    {
      title: "Toplam",
      key: "daily_amount",
    },
    {
      title: "Gönderi Tipi",
      key: "par_delivery_type",
    },
    {
      title: "Standart Teslimat",
      key: "daily_std",
    },
    {
      title: "Aynı Gün Teslimat",
      key: "daily_sd",
    },
    {
      title: "Ertesi Gün Teslimat",
      key: "daily_nd",
    },
  ];
  const searchKeys = [];
  return { columns, excelColumns, searchKeys };
};

export default useLogics;
